module.exports = __webpack_public_path__ + "img/lazer2.1c2af024.svg";